export default __webpack_public_path__ + "static/media/Wolf's Belt of the Wicked Hearth.9c8f85ab.jpg";